export default __webpack_public_path__ + "static/media/13_1.6c164d85.jpg";